<button [id]="instanceId" class="btn btn-primary" (click)="openCodeEditor()" [disabled]="disabled">
  <i class="fa fa-code"></i> Open Code Editor
</button>
